import { CUSTOMER_TABS, defineModule } from "@motolynk/app-core";

import { CustomerWishlistTab } from "./admin/CustomerWishlistTab";

import en from "./i18n/en.json";

export const wishlistModule = defineModule({
  name: "wishlist",
  label: "Wishlist",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
  ],
  i18n: { en },
  // The customer's wishlist is a storefront page (Phase 6); the admin sees it on the customer page.
  admin: {
    routes: [],
    nav: [],
    slots: {
      [CUSTOMER_TABS]: [
        {
          id: "wishlist",
          label: "wishlist:customerTab.label",
          permission: "wishlist.view_wishlistitem",
          component: CustomerWishlistTab,
        },
      ],
    },
  },
  vendor: { routes: [], nav: [] },
});
